import React, { useEffect, useState, useTransition } from "react";
import Header from "../components/Header";
import { ReactComponent as MoreArrow } from "../assets/svg/ReadMore.svg";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { apiRoutes } from "../api/apiRoutes";
import { Helmet } from "react-helmet";
import useLocale from "../locales";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loading/loadingSlice";
import Loader from "../components/Loader";
import { createSlugWithId } from "../utils/slugUtils";
import getImageUrl from "../utils/imageUrl";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const { i18n, t } = useTranslation();
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { textData } = useLocale();
  const { blogsheader, moreoption } = textData;

  const lang = sessionStorage.getItem("lang");
  console.log("lang :", lang);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchBlogs() {
      try {
        dispatch(setLoading(true));
        const response = await axiosInstance.get(`${apiRoutes.GET_ALL_BLOG}`, {
          params: { lang },
        });
        console.log("response :", response);
        dispatch(setLoading(false));
        setBlogs(response?.data?.data);
      } catch (error) {
        setError(error.message);
      } finally {
        dispatch(setLoading(false));
        // setLoading(false);
      }
    }
    fetchBlogs();
  }, [lang]);

  const handleNavigation = ( slug) => {
    // const slug = createSlugWithId(title, blogId);
    navigate(`/blog/${slug}`);
  };

  return (
    <>
      <Helmet>
        <title>GrowLifeFund Blog | Smart Finance Tips and Insights</title>
        <meta
          name="description"
          content="Explore the GrowLifeFund Blog for expert financial tips, money insights, investment guides, and loan advice to help you make confident financial decisions."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/blog" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="GrowLifeFund Blog | Smart Finance Tips and Insights"
        />
        <meta
          property="og:description"
          content="Explore the GrowLifeFund Blog for expert financial tips, money insights, investment guides, and loan advice to help you make confident financial decisions."
        />
        <meta property="og:url" content="https://growlifefund.com/blog" />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Stay tuned for our latest articles and insights on a healthy pregnancy."
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header />
      <div className="max-w-[1280px] md:px-0  px-0 mx-6 sm:mx-5 xl:mx-auto">
        {/* Breadcrumb */}
        <div className="mt-6 pb-5">
          <div className="flex items-center">
            <span
              className="text-blue-shade text-sm sm:text-base md:text-lg xl:text-xl font-medium cursor-pointer"
              onClick={() => navigate("/")}
            >
              {blogsheader.home}
            </span>
            <span className="mx-2">{">"}</span>
            <span className="text-gray-font text-sm sm:text-base md:text-lg xl:text-xl font-medium">
              {blogsheader.blogs}
            </span>
          </div>
        </div>

        {/* Blogs Section */}
        <div className="">
          <div className="text-center">
            <h1 className="text-lg sm:text-xl lg:text-[22px] xl:text-[26px] font-bold text-black">
              {blogsheader.title}{" "}
              <span className="text-primary"> {blogsheader.subtitle}</span>
            </h1>
            <p className="text-gray-font max-w-[904px] mx-auto font-normal text-base sm:text-base lg:text-base pt-4">
              {blogsheader.description}
            </p>
          </div>

          {/* Step 2: Render using map */}
          <div
            className="grid sm:grid-cols-2 md882:grid-cols-3 lg:grid-cols-2 
            gap-x-7 sm:gap-x-[16px] lg:gap-x-[28px] xl:gap-x-[28px]
           gap-y-[20px]  sm:gap-y-[30px]  lg:gap-y-[30px]  xl:gap-y-[50px] 
           xl:pt-[80px] md:pt-[40px] pt-[20px]"
          >
            {blogs?.map((blog, index) => {
              return (
                <div
                  key={index}
                  className=" rounded-[30px] overflow-hidden object-contain  border border-solid border-gray-light bg-white"
                >
                  {/* Image */}
                  <img
                    className="w-full h-[304px] object-cover"
                    src={getImageUrl(blog?.blogImage)}
                    alt={blog?.title}
                  />

                  {/* Content */}
                  <div className="p-5 md882:p-3 lg:p-5">
                    {/* Author & Date */}
                    <h3 className="flex justify-between text-gray-font text-sm font-medium pb-4 sm:pb-[23px]">
                      <span>{blog?.authorName}</span>
                      <span>{blog?.publishedDate.split("T")[0]}</span>
                    </h3>

                    {/* Title */}
                    <h2 className=" text-base md:text-lg xl:text-xl font-bold text-black h-7 line-clamp-1 my-4">
                      {blog?.title}
                    </h2>

                    {/* Description */}
                    <p className="text-gray-font text-[15px] sm:text-base font-medium mb-4 sm:pb-[23px] h-[70px] line-clamp-3">
                      {blog.description}
                    </p>

                    {/* Read More */}
                    <button
                      onClick={() => handleNavigation(blog.slug)}
                      className="text-primary font-medium text-base md882:text-lg lg:text-xl flex items-center gap-2"
                    >
                      {moreoption.readmore}
                      <MoreArrow />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
